/**
 * The column displays a resource's active contract hours.
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { EntityQuery } from 'breeze-client';
import * as moment from 'moment';
import { DomainService } from '../../domain.service';
import { ComponentRegistry } from '../../core/component-registry';
import { durationToText } from '../../core/helpers/durationToText';
import { ColumnProvider } from '../../base/column-provider';
import { ColumnBase } from '../../base/columns/column-base/column-base';
/**
 * The column displays a resource's active contract hours.
 * @export
 * @class ColumnContractHoursComponent
 * @extends {ColumnBase}
 * @implements {OnDestroy}
 */
var ColumnContractHoursComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnContractHoursComponent, _super);
    /**
     * Creates an instance of ColumnContractHoursComponent.
     * @param {ColumnProvider} provider Contains the resource OID.
     * @param {ChangeDetectorRef} changeDetector The parameter is not used.
     * @param {DomainService} domainService Can query the active contract hours.
     * @memberOf ColumnContractHoursComponent
     */
    function ColumnContractHoursComponent(provider, changeDetector, domainService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.provider = provider;
        _this.changeDetector = changeDetector;
        _this.domainService = domainService;
        /**
         * The string representation of the active contract hours.
         * @memberOf ColumnContractHoursComponent
         */
        _this.value = '';
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnContractHoursComponent.register = function () {
        ComponentRegistry.register('column', 'contract-hours', ColumnContractHoursComponent);
    };
    /**
     * Sets the displayed value.
     * @memberOf ColumnContractHoursComponent
     */
    ColumnContractHoursComponent.prototype.ngOnInit = function () {
        var _this = this;
        var query = new EntityQuery('ContractHoursOn');
        query.parameters = { oid: this.provider.entity['Oid'], view: new Date() };
        this.domainService.entityManager.executeQuery(query).then(function (response) {
            _this.value = durationToText(moment.duration(response.results[0]['contract']));
            _this.changeDetector.detectChanges();
        });
    };
    return ColumnContractHoursComponent;
}(ColumnBase));
export { ColumnContractHoursComponent };
